var map = {
	"./Bolsward.png": 7676,
	"./Dokkum.png": 7771,
	"./Franeker.png": 5620,
	"./Grotewielen.svg": 9411,
	"./Harlingen.png": 4734,
	"./Hindeloopen.png": 4805,
	"./IJlst.png": 4604,
	"./Leeuwarden.png": 2400,
	"./Sloten.png": 1433,
	"./Sneek.png": 7202,
	"./Stavoren.png": 8318,
	"./Tmar.png": 7656,
	"./Workum.png": 1185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3134;